export default __webpack_public_path__ + "static/media/solution-2-2-mobile.e9db8912.jpg";